import api from "PFCore/api";
import { CustomValue, Id } from "PFTypes";

export type FetchSkillsFrameworkMatchingProfileSkillsResponse = CustomValue[];

export type FetchSkillsFrameworkMatchingProfileSkillsParams = {
  profileId: Id;
  skillsFrameworkId: Id;
};

export const fetchSkillsFrameworkMatchingProfileSkills = (
  params: FetchSkillsFrameworkMatchingProfileSkillsParams
): Promise<FetchSkillsFrameworkMatchingProfileSkillsResponse> =>
  api({
    url: "skills_framework/matching_profile_skills",
    params
  });
